import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class GuestAccountField extends Component {
  constructor(props) {
    super(props);

    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(ev) {
    this.props.onClickHandler(ev);
  }

  render() {
    return (
      <div className="form-group">
        <label>&nbsp;</label>
        <p>
          <sub className="small-print">
            <FormattedMessage
              id="guestAccountField.label"
              defaultMessage="You have a guest account."
            />
            {' '}
            <a href="#guest-send-special-link" onClick={this.onClickHandler}>
              <FormattedMessage
                id="guestAccountField.sendSpecialLink"
                defaultMessage="Send me a special link"
              />
            </a>
            {' '}
            <FormattedMessage
              id="guestAccountField.convertToRealAccountText"
              defaultMessage="to convert to a real account."
            />
          </sub>
        </p>
      </div>
    );
  }
}

GuestAccountField.defaultProps = {
  onClickHandler: () => { alert('onClickHandler callback not implemented'); },
};

export default GuestAccountField;



// WEBPACK FOOTER //
// ./src/desktop/components/signin/guest-account-field.js